import { Box, Checkbox, FormControlLabel, SxProps, Theme } from "@mui/material";
import WorkItemSelectField from "../shared/WorkItemSelectField";

interface IWorkItemSearchFieldResponsibilityProps {
    idSuffix: string,
    onChange: (e: number[]) => void
    options?: any[]
    onChangeCheckbox?: () => void,
    multiple?: boolean
    label?: string | null,
    labelProps?: SxProps<Theme> | undefined,
    isPrimaryChecked?: boolean,
    onChangeIsPrimaryCheckbox?: (e: any) => void,
    isMatchAllResponsibilitlesChecked?:boolean,
    onChangeIsMatchAllResponsibilitlesChecked?: (e: any) => void,
}

const WorkItemSearchFieldResponsibility = (props: IWorkItemSearchFieldResponsibilityProps) => {
    return (
        <>
            <Box>
                <WorkItemSelectField 
                    idSuffix={props.idSuffix}
                    options={props.options} 
                    multiple={props.multiple === undefined ? true : props.multiple} 
                    label={props.label || "Responsibility"}
                    labelProps={props.labelProps}
                    onChange={s => props.onChange(s)} />
            </Box>
            <Box
                sx={{ paddingLeft: '8px' }}>
                <FormControlLabel
                    id={"search-show-primary-"+props.idSuffix}
                    control={<Checkbox
                        checked={props.isPrimaryChecked}  // Controlled by the state
                        onChange={(e) => props.onChangeIsPrimaryCheckbox && props.onChangeIsPrimaryCheckbox(e.target.checked)}
                    />}
                    label='Only show Primary resources' />
                <FormControlLabel
                    id={"search-match-all-responsibilities-"+props.idSuffix}
                    control={<Checkbox
                        checked={props.isMatchAllResponsibilitlesChecked}  // Controlled by the state
                        onChange={(e) => props.onChangeIsMatchAllResponsibilitlesChecked && props.onChangeIsMatchAllResponsibilitlesChecked(e.target.checked)}
                    />}
                    label='Match all responsibilities' />
            </Box>
        </>
    );
}

export default WorkItemSearchFieldResponsibility;